// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__34wWJ","selects":"Documents_selects__1b5Re"};